import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Disclosures } from '../models/disclosures';

@Injectable({
  providedIn: 'root'
})
export class DisclosuresService {

apiUrl = 'https://data2.ifa.com/'

constructor(private http: HttpClient) { }

getDisclosures(query="") : Observable<Disclosures[]> {
  let url = `${this.apiUrl}odata/v1/html_snippets/`
  url+= "?$filter=description eq 'IFC Disclosures 2025-12-29'&$top=1&$orderBy=id desc"
  url+= query
  return this.http.get<Disclosures[]> (url)
}


getHistory(query="") : Observable<Disclosures[]> {
  let url = `${this.apiUrl}odata/v1/html_snippets/`
  url+= "?$filter=description eq 'IFC History of Changes'"
  url+= query
  return this.http.get<Disclosures[]> (url)
}

}


